export default {
    setSidenav(state, name = '') {
        state.sidebarOpen = name;
    }
}
